module.exports = __webpack_public_path__ + "static/media/image-card-9.a5395da0.png";